// https://stripe.com/docs/api/events/types#event_types-account.updated
export enum PaymentStatusesEnum {
	PAYMENT_SUCCEEDED = 'payment_intent.succeeded',
	PAYMENT_FAILED = 'payment_intent.payment_failed',
	PAYOUT_CREATED = 'payout.created',
	CHARGE_REFUNDED = 'charge.refunded',
}
